import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import cx from 'classnames';
import { Size } from '../../types';
import { colors, sizes } from '../../styles';
import AccelerationIcon from './icons/acceleration';
import ArrowBackIcon from './icons/arrow-back';
import ArrowForwardIcon from './icons/arrow-forward';
import ArrowDropdownIcon from './icons/arrow-dropdown';
import ArrowLeftIcon from './icons/arrow-left';
import ArrowProvision from './icons/arrow-provision';
import ArrowRightIcon from './icons/arrow-right';
import BellIcon from './icons/bell';
import BullseyeIcon from './icons/bullseye';
import BusinessIcon from './icons/business';
import CalendarDateIcon from './icons/calendar-date';
import CalendarIcon from './icons/calendar';
import CameraIcon from './icons/camera';
import CaretDownIcon from './icons/caret-down';
import CaretUpIcon from './icons/caret-up';
import CellPhone from './icons/cell-phone';
import ChartIcon from './icons/chart';
import CheckboxCheckedIcon from './icons/checkbox-checked';
import CheckboxUncheckedIcon from './icons/checkbox-unchecked';
import CheckmarkIcon from './icons/checkmark';
import CheckmarkInCircleIcon from './icons/checkmark-in-circle';
import Cigarette from './icons/cigarette';
import ClipboardIcon from './icons/clipboard';
import CloseCircleIcon from './icons/close-circle';
import CogwheelIcon from './icons/cogwheel';
import ColumnsIcon from './icons/columns';
import ClockIcon from './icons/clock';
import CloseIcon from './icons/close';
import CloseMarkIcon from './icons/close-mark';
import CollisionIcon from './icons/collision';
import CopyClipboardIcon from './icons/copy-clipboard';
import CorneringIcon from './icons/cornering';
import CreditCardIcon from './icons/credit-card';
import DashboardIcon from './icons/dashboard';
import DocumentIcon from './icons/document';
import DistractionIcon from './icons/distraction';
import DeviceIcon from './icons/device';
import DownloadIcon from './icons/download';
import DownloadLightIcon from './icons/download-light';
import DrowsyIcon from './icons/drowsy';
import EmailIcon from './icons/email';
import EmptyIcon from './icons/empty';
import ExclamationIcon from './icons/exclamation';
import EyeIcon from './icons/eye';
import FilterIcon from './icons/filter';
import FolderAddIcon from './icons/folder-add';
import FolderClosedIcon from './icons/folder-closed';
import FolderOpenIcon from './icons/folder-open';
import GlobeIcon from './icons/globe';
import HamburgerMenuIcon from './icons/hamburger-menu';
import HardBrakingIcon from './icons/hard-braking';
import HeartIcon from './icons/heart';
import HelpIcon from './icons/help';
import HistoryIcon from './icons/history';
import InboxIcon from './icons/inbox';
import InfoIcon from './icons/info';
import KebabMenuHorizontalIcon from './icons/kebab-menu-horizontal';
import KebabMenuVerticalIcon from './icons/kebab-menu-vertical';
import LabelAddIcon from './icons/label-add';
import LabelIcon from './icons/label';
import LabelSmartIcon from './icons/label-smart';
import LocationIcon from './icons/location';
import LockIcon from './icons/lock';
import LogoIcon from './icons/logo';
import LogsIcon from './icons/logs';
import LooseDeviceIcon from './icons/looseDevice';
import MapHeadingArrow from './icons/map-heading-arrow';
import MinusIcon from './icons/minus';
import MoonIcon from './icons/moon';
import MovingCarIcon from './icons/moving-car';
import NearCollision from './icons/near-collision';
import NearMeIcon from './icons/near-me';
import NoCloudIcon from './icons/no-cloud';
import NoEyeIcon from './icons/no-eye';
import NoSeatBelt from './icons/no-seat-belt';
import NoVideoIcon from './icons/no-video';
import Panic from './icons/panic';
import PhoneIcon from './icons/phone';
import PlayLabelIcon from './icons/play-label';
import PlusCircleIcon from './icons/plus-circle';
import PlusIcon from './icons/plus';
import PrintIcon from './icons/print';
import QRCodeIcon from './icons/qr-code';
import RadioSelected from './icons/radio-selected';
import RadioUnselected from './icons/radio-unselected';
import RebootIcon from './icons/reboot';
import SearchIcon from './icons/search';
import SignOutIcon from './icons/sign-out';
import Speed from './icons/speed';
import SpeedometerIcon from './icons/speedometer';
import StarIcon from './icons/star';
import SunIcon from './icons/sun';
import TailgatingIcon from './icons/tailgating';
import TrainingIcon from './icons/training';
import TrashIcon from './icons/trash';
import UserAddIcon from './icons/user-add';
import UserCircleIcon from './icons/user-circle';
import UserIcon from './icons/user';
import UsersIcon from './icons/users';
import VehicleIcon from './icons/vehicle';
import VeraIcon from './icons/vera';
import VolumeMute from './icons/volume-mute';
import VolumeUp from './icons/volume-up';
import VideoIcon from './icons/video';
import VideoRequest from './icons/video-request';
import Whistle from './icons/whistle';

export type IconName =
  | 'acceleration'
  | 'arrowBack'
  | 'arrowForward'
  | 'arrowDropdown'
  | 'arrowLeft'
  | 'arrowProvision'
  | 'arrowRight'
  | 'bell'
  | 'braking'
  | 'bullseye'
  | 'business'
  | 'calendar'
  | 'calendarDate'
  | 'camera'
  | 'caretDown'
  | 'caretUp'
  | 'cellPhone'
  | 'chart'
  | 'checkboxChecked'
  | 'checkboxUnchecked'
  | 'checkmark'
  | 'checkmarkInCircle'
  | 'cigarette'
  | 'clipboard'
  | 'clock'
  | 'close'
  | 'closeMark'
  | 'closeCircle'
  | 'cogwheel'
  | 'collision'
  | 'copyClipboard'
  | 'cornering'
  | 'columns'
  | 'creditCard'
  | 'dashboard'
  | 'document'
  | 'device'
  | 'distraction'
  | 'download'
  | 'downloadLight'
  | 'drowsy'
  | 'email'
  | 'empty'
  | 'exclamation'
  | 'eye'
  | 'filter'
  | 'folderAdd'
  | 'folderClosed'
  | 'folderOpen'
  | 'globe'
  | 'hamburgerMenu'
  | 'hardBraking'
  | 'heart'
  | 'help'
  | 'history'
  | 'inbox'
  | 'info'
  | 'kebabMenuHorizontal'
  | 'kebabMenuVertical'
  | 'label'
  | 'labelAdd'
  | 'labelSmart'
  | 'location'
  | 'lock'
  | 'logo'
  | 'logs'
  | 'looseDevice'
  | 'minus'
  | 'mapHeadingArrow'
  | 'moon'
  | 'movingCar'
  | 'nearCollision'
  | 'nearMe'
  | 'noCloud'
  | 'noEye'
  | 'noSeatBelt'
  | 'noVideo'
  | 'panic'
  | 'phone'
  | 'playLabel'
  | 'plus'
  | 'plusCircle'
  | 'print'
  | 'qrCode'
  | 'radioSelected'
  | 'radioUnselected'
  | 'reboot'
  | 'search'
  | 'signOut'
  | 'speed'
  | 'speedometer'
  | 'star'
  | 'sun'
  | 'tailgating'
  | 'training'
  | 'trash'
  | 'user'
  | 'userAdd'
  | 'userCircle'
  | 'users'
  | 'vehicle'
  | 'vera'
  | 'volumeMute'
  | 'volumeUp'
  | 'video'
  | 'whistle'
  | 'videoRequest';

export interface Props {
  active?: boolean;
  activeColor?: string;
  baseColor?: string;
  hoverColor?: string;
  className?: string;
  icon?: IconName;
  size?: Size;
}

export const icons = {
  acceleration: <AccelerationIcon />,
  arrowBack: <ArrowBackIcon />,
  arrowForward: <ArrowForwardIcon />,
  arrowDropdown: <ArrowDropdownIcon />,
  arrowLeft: <ArrowLeftIcon />,
  arrowProvision: <ArrowProvision />,
  arrowRight: <ArrowRightIcon />,
  bell: <BellIcon />,
  braking: <HardBrakingIcon />,
  bullseye: <BullseyeIcon />,
  business: <BusinessIcon />,
  calendar: <CalendarIcon />,
  calendarDate: <CalendarDateIcon />,
  camera: <CameraIcon />,
  caretDown: <CaretDownIcon />,
  caretUp: <CaretUpIcon />,
  cellPhone: <CellPhone />,
  chart: <ChartIcon />,
  checkboxChecked: <CheckboxCheckedIcon />,
  checkboxUnchecked: <CheckboxUncheckedIcon />,
  checkmark: <CheckmarkIcon />,
  checkmarkInCircle: <CheckmarkInCircleIcon />,
  cigarette: <Cigarette />,
  clipboard: <ClipboardIcon />,
  clock: <ClockIcon />,
  close: <CloseIcon />,
  closeMark: <CloseMarkIcon />,
  closeCircle: <CloseCircleIcon />,
  cogwheel: <CogwheelIcon />,
  columns: <ColumnsIcon />,
  collision: <CollisionIcon />,
  copyClipboard: <CopyClipboardIcon />,
  cornering: <CorneringIcon />,
  creditCard: <CreditCardIcon />,
  dashboard: <DashboardIcon />,
  distraction: <DistractionIcon />,
  device: <DeviceIcon />,
  document: <DocumentIcon />,
  download: <DownloadIcon />,
  downloadLight: <DownloadLightIcon />,
  drowsy: <DrowsyIcon />,
  email: <EmailIcon />,
  empty: <EmptyIcon />,
  exclamation: <ExclamationIcon />,
  eye: <EyeIcon />,
  filter: <FilterIcon />,
  folderAdd: <FolderAddIcon />,
  folderClosed: <FolderClosedIcon />,
  folderOpen: <FolderOpenIcon />,
  globe: <GlobeIcon />,
  hamburgerMenu: <HamburgerMenuIcon />,
  hardBraking: <HardBrakingIcon />,
  heart: <HeartIcon />,
  help: <HelpIcon />,
  history: <HistoryIcon />,
  inbox: <InboxIcon />,
  info: <InfoIcon />,
  kebabMenuHorizontal: <KebabMenuHorizontalIcon />,
  kebabMenuVertical: <KebabMenuVerticalIcon />,
  label: <LabelIcon />,
  labelAdd: <LabelAddIcon />,
  labelSmart: <LabelSmartIcon />,
  location: <LocationIcon />,
  lock: <LockIcon />,
  logo: <LogoIcon />,
  logs: <LogsIcon />,
  looseDevice: <LooseDeviceIcon />,
  mapHeadingArrow: <MapHeadingArrow />,
  panic: <Panic />,
  minus: <MinusIcon />,
  moon: <MoonIcon />,
  movingCar: <MovingCarIcon />,
  nearCollision: <NearCollision />,
  nearMe: <NearMeIcon />,
  noCloud: <NoCloudIcon />,
  noEye: <NoEyeIcon />,
  noSeatBelt: <NoSeatBelt />,
  noVideo: <NoVideoIcon />,
  phone: <PhoneIcon />,
  playLabel: <PlayLabelIcon />,
  plus: <PlusIcon />,
  plusCircle: <PlusCircleIcon />,
  print: <PrintIcon />,
  qrCode: <QRCodeIcon />,
  radioSelected: <RadioSelected />,
  radioUnselected: <RadioUnselected />,
  reboot: <RebootIcon />,
  search: <SearchIcon />,
  signOut: <SignOutIcon />,
  speed: <Speed />,
  speedometer: <SpeedometerIcon />,
  star: <StarIcon />,
  sun: <SunIcon />,
  tailgating: <TailgatingIcon />,
  training: <TrainingIcon />,
  trash: <TrashIcon />,
  user: <UserIcon />,
  userAdd: <UserAddIcon />,
  userCircle: <UserCircleIcon />,
  users: <UsersIcon />,
  vehicle: <VehicleIcon />,
  vera: <VeraIcon />,
  volumeMute: <VolumeMute />,
  volumeUp: <VolumeUp />,
  video: <VideoIcon />,
  videoRequest: <VideoRequest />,
  whistle: <Whistle />,
};

class IconWrapper extends React.Component<Props, any> {
  public static defaultProps: Props = {
    size: 'md',
    icon: 'info',
    activeColor: colors.black,
    baseColor: colors.grey300,
  };

  render() {
    const {
      active,
      activeColor,
      baseColor,
      hoverColor,
      className,
      size,
      icon,
    } = this.props;

    return (
      <svg
        viewBox="0 0 20 20"
        version="1.1"
        className={cx(className, 'icon', size, {
          hoverColor: !!hoverColor,
        })}
      >
        <g style={{ fill: active ? activeColor : baseColor }}>{icons[icon]}</g>
      </svg>
    );
  }
}

const StyledIcon = styled(IconWrapper)`
  ${sizes.createRules(sizes.icon)};
  &.hoverColor:hover {
    g {
      fill: ${props => props.hoverColor};
    }
  }
`;

export default StyledIcon;
